import Papa from "papaparse";

/**
 * Handler for DDMS file format
 * Note: Add specific DDMS detection and processing logic based on actual file characteristics
 */
export class DDMSHandler {
  
  /**
   * Check if the file is DDMS format
   * TODO: Implement specific DDMS file detection logic
   */
  static isDDMSFile(csvData: string): boolean {
    // Add specific DDMS file detection logic here
    // This is a placeholder - adjust based on actual DDMS file characteristics
    // For example:
    // return csvData.includes('DDMS_SPECIFIC_HEADER');
    return false;
  }

  /**
   * Process DDMS CSV data
   */
  static processDDMSData(csvDataArray: string[]): string[] {
    const csvRowStrArray: string[] = [];
    let isStringFound: boolean = false;

    const studentIDColumn: string[] = [
      'ID',
      'Student ID',
      'Student ID#',
      'student_id',
      'StudentId',
      'Student_ID',
      'first_name',
      'last_name',
      'First',
      'Last'
    ];

    for (let i = 0; i < csvDataArray.length; i++) {
      const csvRowStr = csvDataArray[i];
      
      // Skip blank rows until header found
      if (!studentIDColumn.some((sid) => csvRowStr.includes(sid)) && !isStringFound) {
        continue;
      }
      
      isStringFound = true;
      const csvRowSubStringArray = csvRowStr.split(',');
      const isArrayBlank = csvRowSubStringArray.every((data) => data.trim() === '');

      if (!isArrayBlank) {
        csvRowStrArray.push(csvRowStr);
      }
    }

    return csvRowStrArray;
  }

  /**
   * Parse DDMS data using Papa Parse
   */
  static parseDDMSData(
    csvData: string,
    updateDataCallback: (result: any, file: File) => void
  ): void {
    Papa.parse(csvData, {
      complete: updateDataCallback,
      header: true,
      dynamicTyping: true,
      trimHeaders: true,
      skipEmptyLines: true,
      transform(value: string, field: string | number): any {
        return value.trim();
      },
      transformHeader(header: string): any {
        return header.trim();
      },
    });
  }
}
